const commonZulu = {
    aboutPage: {
        futureSection: {
            description:
                'I-AUTO24.{{ Country_cctld }} ayisiyona nje indawo yezentengiselwano – iwumphakathi owakhelwe phezu kwefa lokwethembeka, ukwaneliseka kwabathengi, kanye nokwenza kahle kwezimoto. Ngokugxila ekusizeni abathengi ukuthi benze izinqumo ezinolwazi, siphinda sichaze indlela {{ Country_people_indication }} abathenga futhi bathengise ngayo izimoto ezisetshenzisiwe. Joyina izinkulungwane ezishintshele ekuthengeni izimoto ngendlela ehlakaniphile.',
            description2:
                'I-AUTO24.{{ Country_cctld }} - Izinga Eliqinisekisiwe, Ukuqiniseka Okuqinisekisiwe',
            title: 'Ukuqhuba Ikusasa Lezimoto Ezisetshenzisiwe e-Afrika'
        },
        heroDescription:
            'I-AUTO24.{{ Country_cctld }} iwumthombo othembekile we-{{ Country_name }} wezimoto ezisetshenzisiwe eziqinisekisiwe, ihola izwekazi njengomthengisi wokuqala wemikhiqizo eminingi yezimoto ezisetshenzisiwe. Umgomo wethu ukuguqula ulwazi lokuthenga izimoto ngekhwalithi, ukungafihli, nokuthembana. Kungakhathaliseki ukuthi uthenga imoto yakho yokuqala noma uyayithuthukisa, sinikeza inkundla lapho ukuqiniseka kuhlangana khona nokulula.',
        heroTitle: 'Lapho Izinga Lihlangana Nokuthembana',
        welcomeToAuto24: 'Wamukelekile ku-AUTO24',
        whyTrustUsSection: {
            description:
                'Sidlulela ngalé kokuthengisa izimoto – sinikeza ukuthula kwengqondo okuphelele',
            pointsDescription:
                'Sidlulela ngalé kokuthengisa izimoto – sinikeza ukuthula kwengqondo okuphelele.',
            pointsDescription1:
                'Yonke imoto ihlolwa ngokucophelela ngabathengi abaqinisekisiwe, kusukela empilweni yenjini kuye ekhwalithi yangaphakathi.',
            pointsDescription2a:
                'Inqubomgomo Yokubuyiselwa Kwezinsuku Ezinhlanu – Awanelisekile? Buyisela ngaphakathi kwezinsuku ezinhlanu.',
            pointsDescription2b:
                'Iwaranti Yezinyanga Eziyisithupha – Ejwayelekile kuzo zonke izimoto eziqinisekisiwe.',
            pointsDescription2c:
                'Amaphakheji Womshuwalense Nezinyanga Zokulungisa Unyaka Owodwa – Shaya ngaphandle kokukhathazeka kusukela osukwini lokuqala.',
            pointsDescription3:
                'Yonke imibhalo yomlando wemoto kanye nephepha lobunikazi iqinisekiswa ngokuphelele ukuze kube semthethweni futhi kusebenze kahle.',
            pointsDescription4:
                'Inqubo elula yokuthengisa noma ukushintshanisa imoto yakho ngamazinga afanelekile.',
            pointsTitle: 'Kungani Izinkulungwane Zithemba i-AUTO24',
            pointsTitle1: 'Ukuhlola Imoto Ngezindawo Eziyi-120',
            pointsTitle2: 'Izinzuzo Ezibheka Abathengi Kuqala',
            pointsTitle3: 'Imibhalo Eqinisekisiwe',
            pointsTitle4: 'Ukuhwebelana Okushesha Nokuvikelekile',
            title: 'Kungani Izinkulungwane Zithemba i-AUTO24'
        }
    },
    browseCars: {
        buttonText: 'Phequlula Zonke Izimoto',
        description:
            'Phequlula izimoto ezisetshenzisiwe eziqinisekisiwe ezilinganiselwe phezulu zase-{{ Country_name }} – zihloliwe ikhwalithi, zifakwe umshuwalense ngokuphelele, futhi zilungele umgwaqo.',
        title: 'Thola Ukugibela Kwakho Okuphelele Namuhla'
    },
    and: 'Futhi',
    buy: 'Thenga',
    sell: 'Thengisa',
    send: 'Thumela',
    finance: 'Ezezimali',
    about: 'Mayelana',
    blogs: 'Amabhulogi',
    blog: 'Ibhulogi',
    tools: 'Amathuluzi',
    callUsAt: 'Sishayele',
    signIn: 'Ngena ngemvume',
    signUp: 'Bhalisela',
    or: 'Noma',
    insure: 'Umshwalense',
    enteremailAddress: 'Faka ikheli le-imeyili',
    enterPassword: 'Faka iphasiwedi',
    rememberMe: 'Ngikhumbule',
    forgotPassword: 'Ukhohlwe iphasiwedi',
    carsAvailable: 'Izimoto ezitholakalayo manje',
    cancel: 'Khansela',
    enterFullName: 'Faka igama eligcwele',
    tellUsYourFullName: 'Sitshele igama lakho eligcwele',
    tellUsYourEmailAddress: 'Sitshele ikheli lakho le-imeyili',
    emailAddress: 'Ikheli le-imeyili',
    mobileNumber: 'Inombolo yomakhalekhukhwini',
    tellUsWhatYouWant: 'Sitshele ukuthi ufuna usizo ngalokuthini',
    sendEnquiry: 'THUMELA ISICELI',
    referralSubmitted: 'Isithenjwa sithunyelwe! Siyabonga ngesithenjwa sakho.',
    byClickingXButton: 'By clicking {{name}} Button, you agree to our',
    termOfUse: 'Imigomo yokusebenzisa',
    privacyPolicy: 'Inqubomgomo yobumfihlo',
    alreadyhaveanAccount: 'Usunayo i-akhawunti?',
    howItWorks: 'Isebenza kanjani',
    howtoBuy: 'Kanjani ukuthenga',
    howtoSell: 'Kanjani ukuthengisa',
    exploreBlogs: 'Hlola amabhulogi',
    car: 'Imoto',
    search: 'Sesha',
    Certified: 'Eqinisekisiwe',
    Inspected: 'Ihlowe',
    ev: 'Ugesi',
    hybrid: 'Ingxubevange',
    phev: 'PHEV',
    petrol: 'Uphethiloli',
    diesel: 'Udizili',
    carburant: 'Carburant',
    other: 'Okunye',
    automatic: 'Okuzenzakalelayo',
    pleaseprovideusyourdetails: 'Sicela usinikeze imininingwane yakho',
    pleaseprovideusyourcardetails:
        'Sicela usinikeze imininingwane yemoto yakho',
    desiredPleaseprovideusyourcardetails:
        'Sicela usinikeze imininingwane yemoto oyifunayo, khetha okungenani eyodwa',
    phonenumberisnotvalid: 'Inombolo yocingo ayivumelekile',
    internalError: 'Iphutha langaphakathi. Sicela uzame futhi noma usithinte.',
    knowaboutyourcarbetterandgetevaluation:
        'Yazi ngemoto yakho kangcono futhi uthole ukulinganiswa kwedili elingcono',
    cardetailssendSuccessfully: 'Imininingwane yemoto ithunyelwe ngempumelelo',
    thanyouforprovidingusdetail:
        'Siyabonga ngokusinika imininingwane. Sizokufonela maduze.',
    selectbrand: 'Khetha uhlobo',
    selectcountry: 'Select country',
    enterMileage: 'Enter Mileage',
    minMileage: 'Minimum Mileage',
    maxMileage: 'Maximum Mileage',
    selectmodel: 'Khetha imodeli',
    selectYear: 'Khetha unyaka',
    selectorenterbrand: 'Khetha noma ufake ibhrendi',
    selectorentermodel: 'Khetha noma ufake imodeli',
    selectorenterbodyType: 'Khetha noma faka uhlobo lomzimba',
    brand: 'Uphawu',
    model: 'Imodeli',
    modelYear: 'unyaka oyimodeli',
    selectFuelType: 'Khetha uhlobo lukaphethiloli',
    selectACondition: 'Khetha umbandela',
    phoneNumber: 'Inombolo yocingo',
    phonePlaceholder: 'Enter your phone number',
    loanTitle: 'Sikunikeza okunikezwayo okuhle kakhulu, thola inzalo engu-10%',
    loanHappyCusSubtitle:
        'Siyawakhathalela amakhasimende ethu kanye nenjabulo yawo okusikhuthaza ukuthi sihlinzeke ngamasevisi amaningi',
    loanButton: 'Bala imali engiyibolekile',
    calculateButton: 'Calculate',
    blogTitle: 'Bheka ngaphambi kokuthenga imoto',
    blogSubtitle:
        'Lezi izinto okumele uzazi ngaphambi kokuthenga noma yiluphi uhlobo lwemoto',
    viewAllCars: 'Buka zonke izimoto',
    viewAllResultsFor: 'Buka wonke imiphumela ye',
    availableNowOn: 'Iyatholakala manje',
    account: 'i-Akhawunti',
    myAccount: 'i-Akhawunti yami',
    ourBrands: 'Imikhiqizo yethu',
    contactUs: 'Xhumana nathi',
    contactInformation: 'Ulwazi lokuxhumana',
    aboutUs: 'Mayelana nathi',
    addressLine: 'Ulayini we kheli',
    contact: 'Contact',
    whyChooseAuto: 'Why Choose AUTO24?',
    allcarshavebeenthoroughlyinspectedandreconditionedHowweguaranteecarquality:
        'Zonke izimoto zihlolisiwe futhi zalungiswa kabusha. Siqinisekisa kanjani izinga lemoto',
    imInterested: 'Nginentshisekelo',
    buyOnline: 'Buy Online',
    downPayment: 'Inkokhelo yokubambisa',
    hotDeal: 'Isivumelwana esishisayo',
    lowPrice: 'Intengo ephansi',
    likeNew: 'Njengokusha',
    moneybackSubtitle: "You don't like the car? We refund you",
    warrentyTitle: 'Iwaranti yezinyanga eziyisi-6',
    warrentySubtitle:
        'Inwetshwa ibe yizinyanga eziyi_12 enjinini, ebhokisini legiya kanye naku-powertrain',
    inspectionPointsSubtitle:
        'Ihlolwe ithimba lethu lochwepheshe bezimoto kuwo wonke ama-engeli',
    roadSideAssistanceTitle: 'Usizo lonyaka owodwa',
    roadSideAssistanceSubtitle:
        'Usizo lomgwaqo olufakwe kuzo zonke izimoto zethu, unyaka owodwa',
    deliveryTitle: 'Ukulethwa ekhaya',
    deliverySubtitle: 'We can deliver your car anywhere in South Africa',
    xDeliverySubtitle: 'We can deliver your car anywhere in {{country}}',
    Summary: 'Isifinyezo',
    engine: 'Injini',
    enginePower: 'Injini',
    fuelType: 'Uhlobo lwamafutha',
    buildYear: 'Yakha Unyaka',
    bodyType: 'Uhlobo lomzimba',
    numberofkeys: 'Inombolo yezihluthulelo',
    exteriorColor: 'Umbala wangaphandle',
    interiorColor: 'Umbala wangaphakathi',
    engineSize: 'Usayizi wenjini',
    fiscalPower: 'Amandla ezimali',
    specifications: 'Imininingwane',
    specification: 'Imininingwane',
    lengthWidthHeight: 'Ubude, ububanzi & ukuphakama',
    weight: 'Isisindo',
    emissionCO2: 'Ukukhishwa kwe-CO2',
    fuelConsumption: 'Ukusetshenziswa kukaphethiloli',
    enginepower: 'Amandla enjini',
    fuelTankCapacity: 'Umthamo wethangi likaphethiloli',
    'performance&Economy': 'Ukusebenza',
    features: 'Izici',
    'weight&Dimensions': 'Isisindo & izilinganiso',
    showMoreFeatures: 'Khombisa izici ezengeziwe',
    showLess: 'Khombisa okuncane',
    serviceHistory: 'Umlando wesevisi',
    whyAUTO24: 'Kungani i-AUTO24',
    serviceCenter: 'Isikhungo senkonzo',
    Kilometers: 'Km',
    lookingForaCarQtellUs: 'Ufuna imoto? Sitshele!',
    sellPageTitle: 'Thengisa imoto yakho ngezinyathelo ezimbili ezilula',
    sellPageSubtitle:
        'Unganikeza imininingwane ngemoto yakho futhi sizokufonela ukuze uthole amadili angeziwe',
    findCarPricePageTitle: 'Find The Price of Your Car',
    findCarPricePageSubtitle:
        'You can provide details about your car and we will call you back for futher deals.',
    whyFinanceYourCarwithAuto24: 'Kungani ukhokhela ibanga lakho nge-AUTO24',
    financeSubtitle:
        'Sikunikeza iminikelo yezimali engcono kakhulu enenzalo ephansi kanye nezinkokhelo eziphansi',
    competitiveRates: 'Amanani okuncintisana',
    competitiveDesc: 'I-APR kusuka ku-5% (inkomba)',
    competitiveDescMA: 'Amathuba esikweletu samahhala ngaphansi kwemibandela',
    flexiableDuration: 'Ubude besikhathi obuvumelana nezimo',
    flexiableDes:
        'Khokhela imoto yakho ngezitolimende zanyanga zonke eziyi-12 kuya kwezingu-72',
    Percent100OnlineApproach: 'Indlela ye-intanethi engu-100%',
    Percent100OnlineApproachDesc: 'Sayina wonke amadokhumenti akho ekhaya',
    loanCalculatorTitle: 'Umshini wokubala wokubolekwa kwemoto',
    loadCalculatorSubtitle:
        'Isilinganiso senzalo sanyanga zonke singahluka njengoba sibambisene nezikhungo ezahlukene zezimali',
    interestRate: 'Isilinganiso senzalo',
    years: 'Iminyaka',
    ourFinancingPartners: 'Uzakwethu wezezimali',
    ourInsurePartners: 'Uzakwethu womshwalense',
    ourPartners: 'Ozakwethu',
    copyrightfooter: 'Copyright Â© Africar Group Pty Ltd - All rights reserved',
    insureSubtitle:
        'Ujabulele umshwalense ongcono kakhulu ngentengo engcono kakhulu',
    aboutFinanceSub: 'Naba abanye bozakwethu bethu bezemali',
    selectMileageRange: 'Khetha ibanga lemayela',
    selectTransmissionType: 'Khetha uhlobo lokudlulisela',
    backToHome: 'Ngibuyele ekhaya',
    getACallBack: 'Uthole ucingo emuva',
    personalDetails: 'Imininingwane ekhombisa wena',
    carDetails: 'Imininingwane yemoto',
    ourBrandsSubtitle:
        'Sihlotshanisa nemoto yohlobo oluphezulu esiwine imiklomelo eminingi ngokusebenza kahle kakhulu',
    enterCarDetails: 'Enter Car Details',
    ourTeam: 'Amaqembu ethu',
    findCarPrice: 'Isivikelo sokuthengisa',
    teamMembers: 'Abantu bethu',
    ourTeamSubtitle: 'Sazi kangcono ngemicabango yamaqembu ethu',
    latestPosts: 'Okuthunyelwe kwakamuva',
    lastestPostSubtitle:
        'Nanka amabhulogi akamuva avela kubasebenzisi abahlukene',
    featuredPosts: 'Okuthunyelwe okufakiwe',
    featuredPostSubtitle:
        'Nanka amabhulogi afakiwe avela kubasebenzisi abahlukene',
    newsLetterTitle: 'Ungaphuthelwa yindaba',
    newsLetterSubtitle:
        'Bhalisela ibhulogi ye-AUTO24 ukuze uhlale unolwazi mayelana nayo yonke into ngezimoto',
    buySellTitle: 'Usukulungele?',
    buySellSubtitle:
        "Whether it's selling your used car or buying your next ride, we can do it all.",
    sellYourCar: 'Thengisa imoto yakho',
    buyaCar: 'Ukuthenga imoto',
    footerInfo:
        'AUTO24.ci is a subsidiary of Africar Group Pty Ltd, registered in Ivory Coast under the IDU CI-2022-0027564 O.',
    FAQ: 'FAQ',
    buyCars: 'Thenga izimoto',
    sellCars: 'Dayisa izimoto',
    categories: 'Izigaba',
    topStories: 'Izindaba eliphezulu',
    pleaseInputYourPassword: 'Sicela ufake iphasiwedi yakho!',
    donthaveanaccount: 'Anginayo i-akhawunti',
    resetPassword: 'Setha kabusha iphasiwedi',
    editProfile: 'Hlela iphrofayili',
    createNewPassword: 'Dala iphasiwedi entsha',
    passwordresetsuccessfully: 'Ukusetha kabusha iphasiwedi ngempumelelo',
    pleaseInputYourName: 'Sicela ufake igama lakho!',
    pleaseInputYourEmail: 'Sicela ufake ikheli lakho le-imeyili',
    pleaseInputValidEmail: 'Sicela ufake ikheli le-imeyili elivumelekile!',
    pleaseInputYourPhoneNumber: 'Sicela ufake inombolo yakho yocingo!',
    maximumXdigitsisallowed: 'Maximum {{X}} digits is allowed',
    minimumXdigit: 'Minimum {{X}} digits is allowed',
    passwordisRequired: 'Iphasiwedi iyadingeka!',
    minimum8chars: 'Ubuncane bezinhlamvu eziyi-8 buyadingeka',
    usersuccessfullyregistered: 'Umsebenzisi ubhaliswe ngempumelelo!',
    shortBio: 'I-bio emfushane',
    Save: 'Gcina',
    Share: 'Yabelana',
    doyouwantDeleteAccount: 'Do you want to permanently delete your account?',
    delete: 'Susa',
    saveChanges: 'Londoloza izinguquko?',
    youcanstillchangetheseinformation: 'Usengakwazi ukushintsha lolu lwazi',
    changessavedsuccessfully: 'Izinguquko zilondolozwe ngempumelelo',
    yourchangessavedsuccessfully: 'Izinguquko zako zilondolozwe ngempumelelo',
    deleteyourAccount: 'Susa i-akhawunti yakho?',
    deleteAccountsubtitile:
        'Once you delete your account your all data will be lost and you cant  get access to your account.',
    accountdeletedsuccessfully: 'I-akhawunti isuswe ngempumelelo',
    youcanstillexpolrecarwithouthavinganaccount:
        'Usengakwazi ukuhlola izimoto ngaphandle kokuba ne-akhawunti',
    logout: 'Phuma',
    xInspectionPoints: '{{number}} inspection points',
    xlistingPageResultTitle: '{{number}} Cars Found',
    xlistingPageResultsTitle: '{{number}} Cars Found',
    sortBy: 'Hlunga nge:',
    filterBy: 'Hlunga nge:',
    lowestPriceFirst: 'Intengo ephansi kuqala',
    highestMileageFirst: 'Imayela eliphezulu kakhulu kuqala',
    lowestMileageFirst: 'Imayela eliphansi kakhulu kuqala',
    price: 'Intengo',
    mileage: 'Imayela',
    selectBodyType: 'Khetha uhlobo lomzimba',
    filter: 'Izihlungi',
    moreFilters: 'Izihlungi ezengeziwe',
    color: 'Umbala',
    transmission: 'Ukudluliswa',
    highestPriceFirst: 'Intengo ephezulu kuqala',
    provideUsYourDetail: 'Sinikeze imininingwane yakho',
    interestcartitle: 'Uzimisele ukuthenga le moto?',
    interestcarsubtitle:
        'Khetha inketho eyodwa,ezinye zizoqhubeka nokutholakala ohlelweni lwakho lokuthenga',
    bookThisCar: 'Bhuka le moto',
    bookThisCarSubtitle:
        'Chofoza lapha ukuze\nusithumelele isikhokhelo se-{{Price}} {{ Currency }}, sizovimba imoto isonto elilodwa, nje ngawe',
    scheduleAVisit: 'Hlela ukuvakashelwa',
    scheduleAVisitSubtitle:
        'Vakashela isitolo sethu ukuze ubuke imoto oyithandayo. Isazotholakala kwabanye abathengi',
    popularblog: 'Amabhulogi adumile',
    popularblogSub: 'Nanka amabhulogi adumile avela kubasebenzinsi abahlukene',
    category: 'Isigaba',
    carOverview: 'Uhlolojikelele lwemoto',
    Detailssentsuccessfully: 'Imininingwane ithunyelwe ngempumelelo',
    DetailChangeSubtitle:
        'Siyabonga ngokusinika imininingwane yakho. Sizokufonela maduze',
    continue: 'Qhubeka',
    carnotfoundSubtitle:
        'Ayikho imoto etholakalayo ngemibandela ekhethiwe. Sisize ngemininingwane yakho futhi sizokusiza uthole imoto efanele',
    logoutModelTitle: 'Uqinisekile ukuthi ufuna ukuphuma?',
    french: 'IsiFulentshi',
    QuickLinks: 'Izixhumanisi ezisheshayo',
    similarResults: 'Similar Results ',
    copyrightInfo:
        "AUTO24.CI is a subsidiary of Africar Group Pty Ltd, registered under the unique identification number CI-2022-0027564 O in the Republic of Cote d'Ivoire",
    recentlyAdded: 'Okusanda kungezwa',
    recentlyAddedSubtitle: 'Lapha ungabona izimoto ezahlukene esanda wanezela',
    newCarList: 'Izimoto ezisha',
    newCarListSubtitle: `Lapha ungakwazi ukubona izimoto ezisha ezincane`,
    electricCarList: `Izimoto zesitshudeni`,
    electricCarListSubtitle: `Lapha ungakwazi ukubona izimoto ezintsha ezincane eziselekhtriki`,
    importedCarList: `Izimoto ezinzuzo`,
    importedCarListSubtitle: `Lapha ungakwazi ukubona izimoto ezinzuzo ezincane`,
    cheapestCarList: 'Imoto ezinzima ezincane phezu kwama {{X}}',
    cheapestCarListSubtitle:
        'Lapha ungakwazi ukubona imoto ezithokozisa ezahlukene phansi kwama {{X}}',
    hereyoucanseedifferentsimilarcars:
        'Lapha ungabona izimoto ezahlukene ezifanayo',
    carNotFound: 'Imoto ayitholakali',
    whatsappUrlText: 'Sawubona! Ngiyayithanda le moto',
    latestService: 'Isevisi yakamuva',
    resetSuccessMsg:
        'Manje ungangena ngemvume ngephasiwedi yakho entsha noma usengahlola izimoto',
    bothPasswordMustMatch: 'Womabili amaphasiwedi kumele afane',
    mustBeAtleast8Characters: 'Kufanele okungenani ibe nezinhlamvu ezingu-8',
    sendResetLink: 'Thumela isixhumanisi sokuphumula',
    returnTo: 'Buyela ku',
    enterEmailToGetResetLinkInfo:
        'Faka i-imeyili ehlobene ne akhawunti yakho futhi sizokuthumela i-imeyili enemiyalelo yokusetha kabusha iphasiwedi yakho',
    resetPasswordModalTitle:
        'Uqinisekile ukuthi ufuna ukusetha kabusha iphasiwedi yakho?',
    yourPasswordChangedSuccessfully: 'Iphasiwedi yakho ishintshwe ngempumelelo',
    confirmPassword: 'Qinisekisa iphasiwedi',
    carViewsXTimes: 'Viewed {{number}} times today',
    shortDescription: 'Incazelo emfushane',
    carImages: 'Izithombe zemoto',
    uploadImage: 'Layisha isithombe',
    browse: 'Phequlula',
    listAnother: 'Bhala enye',
    listCarRequestSentSucessfully:
        'Isicelo sohlu lwemoto sithunyelwe ngempumelelo',
    basicDetails: 'Imininingwane eyisisekelo',
    manual: 'Imanuwali',
    postYouHaveLiked: 'okuthunyelwe okuthandile',
    enterOldPassword: 'Faka iphasiwedi endala',
    enterPrice: 'Faka Intengo yakho',
    enterNewPassword: 'Iphasiwedi entsha',
    confirmNewPassword: 'Qinisekisa iphasiwedi entsha',
    passwordChangeSuccessfully: 'Iphasiwedi ishintshwe ngempumelelo',
    verificationTitle:
        'Sikuthumelele isixhumanisi sokuqinisekisa ekhelini lakho le-imeyili',
    viewLink: 'Buka isixhumanisi',
    resendingLink: 'Thumela kabusha isixhumanisi',
    tokenExpired: 'Uphawu lwakho luphelelwe yisikathi sicela udale entsha',
    tokenExpiredTitle:
        'Isixhumanisi sokuniqisekisa i-akhawunti yakho siphelelwe yisikathi',
    callBackSubtitle:
        "Enter your name and phone number we'll get back to you soon",
    provideUsYourDetails: 'Sinikeze imininingwane yakho',
    showCars: 'Khombisa izimoto',
    accountVerifiedSuccessfully: 'I-akhawunti iqinisekiswe ngempumelelo',
    accountVerifiedSuccessfullySubtitle:
        'Your account has been verified successfully. Do you want to login?',
    engineSound: 'Umsindo wenjini',
    showAllImage: 'Khombisa zonke izithombe',
    ourBenefits: 'Izinzuzo zethu',
    inspectionPoints: 'Amaphuzu okuhlola ayi-100 ngochwepheshe bethu bezimoto',
    warranties:
        'Iwaranti yezinyanga eziyisi-6 (injini, ibhokisi legiya ne-ekseli)',
    maintenances: '1 year maintenance package with AUTO24.co.za',
    assistance: 'Izinyanga eziyi-12 usizo lokudonsa nokudiliza',
    multiCurrency: 'Multi-currency payment DH, €, $, £',
    moneyBack: 'Isiqinisekiso sokubuyiselwa imali sezinsuku ezi-5',
    financing: 'Financing ',
    dragAndDrop: 'Hudula bese uphonsa isithombe noma',
    imageFormat: 'Amafomethi asekelwayo:JPEG,PNG',
    sellNow: 'Thengisa manje',
    confirm: 'Qinisekisa',
    didntFindQuestion: "Didn't find the question you're looking for?",
    yourMessage: 'Umlayezo wakho',
    sendMessage: 'Thumela umlayezo',
    loanTenure: 'Isikhathi sokubolekwa imali',
    selectLoanTenure: 'Select Loan Tenure',
    interestInput: 'Enter amount between ({{X}} and {{Y}})',
    months: 'Izinyanga',
    from: 'Kusuka',
    upto: 'Kuya ku',
    rateOfInterest: 'Izinga lenzalo',
    tenure: 'Isikhathi sokuhlala',
    monthlyEmi: 'EMI ngenyanga',
    loadMore: 'Layisha okuningi',
    contactSubtitle: 'Unemibuzo? Ukhululekile ukusithumelela umlayezo',
    inspector: 'Umhloli',
    inspectorSubtitle: 'Cela umhloli',
    insurance: 'Umshwalense',
    insuranceSubtitle: 'Cela umshwalense ongcono kakhulu',
    financeSubtitles: 'Cela imali engcono kakhulu',
    diagnostic: 'Zokuxilonga',
    minPrice: 'Intengo encane',
    maxPrice: 'Intengo enkulu',
    minDistance: 'Ibanga elincane',
    maxDistance: 'Ibanga elikhulu',
    min: 'Min',
    max: 'Max',
    diagonosticSubtitle: 'Cela ukuxilonga',
    VINVerify: 'Qinisekisa i-VIN',
    VINVerifySubtitle: 'Cela ukuqinisekiswa kwe-VIN okusheshayo\n',
    learnMore: 'Funda kabanzi',
    speedRegular: 'Isilawuli sesivinini',
    airCondition: 'Isimo somoya',
    sequential: 'Ngokulandelana',
    CDPlayer: 'Isidlali se-CD',
    reversingCamera: 'Ikhamera ehlehlayo',
    reversingRadar: 'I-radar ehlehlayo',
    GPSNavigation: 'GPS yokuzulazula',
    parkAssist: 'Usizo lwepaki',
    startAndStop: 'Qala futhi ume',
    airbag: 'Isikhwama somoya',
    ABS: 'ABS',
    computer: 'Ikhompuyutha',
    rims: 'Amarimu',
    sunroof: 'Uphahla lwelanga',
    electricMirrors: 'Izibuko zikagesi',
    electricWindows: 'Amawindi kagesi',
    dateFirstUse: 'Usuku lokuqala ukusetshenziswa',
    seats: 'Izihlalo',
    certifiedUsedCars: 'Izimoto ezisetshenzisiwe eziqinisekisiwe',
    certifiedUsedCarsSubtitle:
        'Thenga izimoto esezike zasentshenziswa ngokwethembeka nangokusobala',
    inpectionsPoints: 'Amaphuzu okuhlola ayi-100',
    inpectionsPointsSubtitle: 'Zonke izimoto zethu zihlolwe kahle',
    refundPolicy: 'Inqubomgomo yembuyiselo yezinsuku ezi-5',
    refundPolicySubtitle: "You don't like it, get refunded!",
    warrentySubtitles:
        'Injini, ibhokisi yegiya kanye ne-powertrain, izinyanga eziyisi-6 ziqinisekisiwe',
    excellentCondition: 'Isimo esihle kakhulu',
    goodCondition: 'Isimo esihle',
    averageCondition: 'Isimo esimaphakathi',
    damagedCar: 'Imoto eyonakele',
    lessThan10: 'Ngaphansi kuka-10 000 km',
    betweenXAndY: 'Between {{X}} and {{Y}} km',
    moreThan100: 'Ngaphezu kuka-10 000 km',
    serviceTitle: 'Ukuthenga noma ukuthengisa? Singakusiza',
    serviceSubtitle:
        'Explore our services and make your car buying / selling experience seamless ',
    verifyAccount: 'Qinisekisa i-akhawunti',
    verifyNumber: 'Qinisekisa inombolo',
    otpVerificationSubtitle:
        'Enter the 5 digit code sent to {{code}} {{number}}',
    otpVerificationEmail: 'Enter the 5 digit code sent to {{email}}',
    didntGetTheCode: "Didn't get the code?",
    resendCode: 'Thumela kabusha ikhodi',
    bluetooth: 'Bluetooth',
    home: 'Ekhaya',
    lookingForBestInsurance: 'Ufuna umshwalense ongcono kakhulu?',
    ourCustomerRepresentativesWillGetBackInTouchWithYou:
        'Abamele amakhasimende ethu bazophinde baxhumane nawe',
    upload: 'Layisha',
    profileUpload: 'Layisha isithombe esisha',
    remove: 'Susa',
    xIsrequired: '{{name}} is required',
    number: 'Inombolo',
    backToCarDetail: 'Buyela ekhasini lemininingwane',
    backToTheCarDescription: 'Buyela encazelweni yemoto',
    backToTheCarListing: 'Buyela ohlwini lwezimoto',
    phoneVerifiedSuccesfully: 'Ifoni iqinisekiswe ngempumelelo',
    phoneVerifiedSubtitle:
        'Your phone number has been verified successfully. Do you want to login',
    signWithPhone: 'Ngena ngemvume ngefoni',
    signWithEmail: 'Ngena ngemvume nge-imeyile',
    newPriceFrom: 'Intengo yemoto entsha kusuka',
    theySpeakAboutUs: 'Bakhuluma ngathi',
    theySpeakAboutUsSubTitle:
        'Ukukhethwa kwabahloli babezindaba bamazwe ngamazwe abakhumuluma nge-AUTO24',
    carLoanSubTitle: 'Inkokhelo yenyanga zonke elinganiselwe',
    carLoanTotalRepayment: 'Inani eliphelele lokubuyisela',
    forgotTokenExpired:
        'Isixhumanisi sokusetha kabusha iphasiwedi siphelelwe yisikathi',
    discover: 'Thola imoto',
    paperWork: 'Amaphepha ezimoto asesikhathini samnje futhi aqinisekisiwe',
    verifyhistory: 'Siqinisekisa umlando wazo zonke izimoto esizithengayo',
    buyBack: 'Sithenga futhi imoto yakho endala',
    additionalPhotos: 'Izithombe ezengeziwe',
    inspectionReports: 'Imibiko yokuhlolwa',
    referenceLink: 'Isixhumanisi sereferensi',
    technicalVisit: 'Isitifiketi sokuvakasha kobuchwepheshe',
    keysPhotos: 'Izithombe zokhiye',
    seeKeyPhotos: 'Bona isithombe',
    pleaseTryAfterSomeTime: 'Ngicela uzame emva kwesikhathi',
    favourites: 'Izintandokazi',
    electric: 'Kagesi',
    autonomy: 'Ukuzimela',
    productionYear: 'Unyaka wokukhiqiza',
    payWithOtherCurrencytitle: 'Khokha ngolunye uhlobo lwemali nge-AUTO24',
    payWithOtherCurrencySubtitle:
        'Nge-AUTO24,ungakhokha kwenye yama-akhawunti ethu ebhange lamazwe ngamazwe kunoma yiziphi izinhlobo zemali ezingezansi. Nali inani ongayidinga ukuze ulidlulisele',
    convertedPrice: 'Intengo eguquliwe',
    favouritesNotFoundSubtitle:
        "You haven't added any cars to favourites. Explore cars and add your favourites",
    noFavouritesFound: 'Azikho izintandokazi ezitholakele',
    frontCrankOilSeal: 'Uphawu lwamafutha e-crank angaphambili',
    engineOverHaul: 'Ukulungiswa kwenjini',
    rearCrankOilSeal: 'Uphawu lwamafutha e-crank yasemuva',
    engineTuneUp: 'Lungisa injini',
    engineMount: 'I-mount ye injini',
    oilPanGasket: 'I-oil pan gasket',
    valveCoverGasket: 'I-valve cover gasket',
    oilFilterBracketOring: 'Ubakaki wokuhlunga uwoyela oring',
    intakeManifoldGasket: 'I-intake manifold gasket',
    waterLeak: 'Ukuvuza kwamanzi',
    radiator: 'Irediyetha',
    engineTimingCoverGasket: 'Injini yesikhathi ikhava gasket',
    waterPump: 'Umthombo wamanzi',
    belts: 'Amabhande',
    fuelFilter: 'Isihlungi sikaphethiloli',
    airFilter: 'Isihlungi somoya',
    underChassis: 'Ngaphansi kwe-chassis',
    tieRod: 'Induku yokubopha',
    ballJointLandR: 'Ibhola elihlangene L&R',
    idlerArm: 'Ingalo evilaphayo',
    pitmanArm: 'Ingalo ye-pitman',
    steeringPump: 'Iphampu yokuqondisa',
    steeringHoses: 'Amapayipi okuqondisa',
    steeringBox: 'Ibhokisi lokuqondisa',
    steeringRackAndPinion: 'I-steering rack kanye ne-pinion',
    frontShockLandR: 'Ukushaqeka ngaphambili L&R',
    rearShockLandR: 'Ukushaqeka kwangemuva L&R',
    stabilizerLinkage: 'Ukuxhumana kwe Isizinzisi',
    crossJointPropellerShaft: 'Isiphambano se propeller shaft',
    upperArmBushing: 'Ukuqhumana kwengalo engaphezulu',
    rearLowerArmBushing: 'Ngemuva kwengalo engezansi',
    suspensionSpring: 'Intwasahlobo yokumiswa',
    breakSystem: 'Uhlelo lokuphumula',
    brakePad: 'Iphedi yebrake',
    brakeDiscRotor: 'I-brake disc rotor',
    wheelBearing: 'Isondo elithwalayo',
    brakeMasterCLY: 'I-brake master CLY',
    backBooster: 'I-booster yasemuva',
    brakeWheelCall: 'Ukukhala kwesondo eliphukayo',
    handBrakeCable: 'Ikhebulu le-brake yesandla',
    brakeHoses: 'Amapayipi we-brake',
    rearAxlesAndDriveShafts: 'Ama ekseli angemuva kanye namashafts okushayela',
    frontAxle: 'Iekseli yangaphambili',
    rearAxle: 'Iekseli yangemuva',
    axleDifference: 'Umehluko weekseli',
    differenceFrontOrRear: 'Difference Front Or Rear',
    axleSealFrontOrRear: 'Axle Seal Front Or Rear',
    oilPumpGasket: 'Oil Pump Gasket',
    frontOilSeal: 'Front Oil Seal',
    rearOilSeal: 'Rear Oil Seal',
    transmissionMount: 'Transmission Mount',
    gearStickSouta: 'Gear Stick Souta',
    oilCollerPipe: 'Oil Cooler Pipe',
    gearPerformance: 'Gear Performance',
    liquidSystem: 'Liquid System',
    engineOil: 'Engine Oil',
    transmissionOil: 'Transmission Oil',
    brakeFluid: 'Brake Fluid',
    engineCoolant: 'Engine Coolant',
    washerFluid: 'Washer Fluid',
    electricitySystem: 'Electricity System',
    battery: 'Battery',
    alternator: 'Alternator',
    starler: 'Starler',
    lights: 'Lights',
    ac: 'A/C',
    centerLock: 'Center Lock',
    wiperBlades: 'Wiper Blades',
    troubleCode: 'Trouble Code',
    computerCods: 'Computer Cods',
    acCondensor: 'A/C Condenser',
    acRadiator: 'A/C Radiator',
    interior: 'Interior',
    seatAndBelts: 'Seats And Belts',
    interiorControlsAndSwitches: 'Interior Controls And Switches',
    sunRoofAndWindows: 'Sun Roof And Windows',
    fuelAndTemperatureGauge: 'Fuel And Temperature Gauge',
    dashboardAndGauges: 'Dashboard And Gauges',
    radioOrMusicSystem: 'Radio Or Music System',
    sRSAirbags: 'SRS Airbags',
    steeringWheelTiltOrlock: 'Steering Wheel Tilt Or Lock',
    mirrors: 'Mirrors',
    bodyInspection: 'Body Inspection',
    inspectionDate: 'Inspection Date',
    carInspectionReport: 'Car Inspection Report',
    showPicture: 'Show Picture',
    pageNotFound: 'Page Not Found',
    pageRemoved: "This page doesn't exist or was removed!",
    askQuestionOnWhatsapp: 'Questions? Ask us on whatsapp!',
    whatsappsPlaceholder: 'Ask anything!',
    customerSupport: 'Customer Support',
    needHelpChatWithUs: 'Need Help? Chat with us on Whatsapp',
    instaTitle: 'Follow us on Instagram',
    instaSubTitle:
        'Get updated with our latest offers, products and news instantly!',
    questionSentSuccessfully: 'Question Sent Successfully',
    questionSentSuccessfullySubtitle:
        'Your question has been sent successfully. We will get back to you for your answer',
    unSubscribeMessage:
        'You have been successfully unsubscribed from the Auto24 Blogs.',
    numberMustBeUnique: 'Number must be unique',
    pleaseEnterFullName: 'Sicela ufake igama eligcwele',
    saving: 'Saving',
    sending: 'Sending',
    signingIn: 'Signing In',
    signingUp: 'Signing Up',
    loggingout: 'Logging out',
    deleting: 'Deleting',
    querySubmittedSuccessfully: 'Query submitted successfully',
    somethingWentWrong: 'Something went wrong!',
    removedFromWishlist: 'Removed from wishlist !!',
    addedToWishlist: 'Added to wishlist !!',
    subscribedSuccessfully: 'Subscribed successfully',
    alreadySubscribed: 'Already subscribed',
    messageIsRequired: 'Message is required',
    fullName: 'Full Name',
    email: 'I-imeyili',
    message: 'Umlayezo',
    queries: 'Imibuzo',
    feedback: 'Impendulo',
    queriesDescription:
        'Unemibuzo mayelana nezimoto zethu noma amasevisi? Silapha ukukusiza ngayo yonke imibuzo yakho.',
    feedbackDescription:
        'Yabelana nolwazi lwakho nathi. Impendulo yakho isinceda ukuthuthukisa amasevisi ethu.',
    getInTouchWithUs: 'Xhumana nathi',
    phoneNumberVerifiedSuccess:
        'Phone number verified successfully, Please login.',
    verifyEmail:
        'Please verify your email for Auto24, Verification link has been sent to your email',
    sold: 'Kuthengisiwe',
    new: 'Okusha',
    used: 'Esetshenzisiwe',
    popular: 'Idumile',
    makes: 'Imikhiqizo',
    carTypes: 'Izinhlobo zezimoto',
    explore: 'Phanda',
    followUS: 'Landela thina',
    none: 'Lutho',
    all: 'Zonke',
    discount: 'Discount',
    careers: 'Imisebenzi',
    year: 'Year {{X}} and above',
    discountOff: '{{X}} Remise',
    financeYourCarWith: 'Finance Your Car With',
    creditButton: 'CREDIT GRATUIT',
    loanPaymentSimulator: 'Isibali-mali sesikweletu semoto',
    loanPaymentContent:
        'Sikwenzela kube lula ukuba ube nemoto oyifunayo. Masikusize uthole isikweletu, kusukela ekufakweni kwemibhalo kuya ekutholeni ukuqinisekiswa kwesikweletu ngokushesha.',
    loanCalculatorContent:
        'Izinga lenzalo lanyanga zonke lingase lihluke njengoba sibambisene nezikhungo ezahlukene zezimali.',
    vehiclePrice: 'Vehicle price',
    noOfMonthlyPayments: 'Number of monthly payments',
    monthlyPaymentAmount: 'Monthly payment amount',
    creditRequestedAmount: 'Credit Requested Amount',
    overallCostOfCredit: 'Isikweletu esiphelele',
    simulatorContribution: 'Simulator contribution',
    percentageOfContribution: 'Percentage of contribution',
    applicationFees: 'Application fees',
    monthlyInsurance: 'Monthly insurance',
    noOfOwners: 'Number Of Owners',
    condition: 'Condition',
    maisonMere: 'Maison Mere',
    imported: 'Imported',
    tamperedOdometer: 'Tampered Odometer',
    carIssue: 'Car Issues',
    evaluateAgain: 'Evaluate Again',
    marketValue: 'Market Value',
    downloadAuto24App: `Thwebula i-App ye-Auto24`,
    browseMore: `Shintsha, thenga, uceke ngeqiniso - unqubomgomo wakho wezimoto ovuthayo`,
    saveTimeAndEffort: 'Thenga Isikhathi Nengqalasizinda',
    saveTimeAndEffortSubtitle: `Vumelan' ukuthi sithengele isikhathi esimangalisayo njengoba sizimela konke, sikwazi ukwenza ukuthengisa ngokuphelele futhi ngokuphepha`,
    freeNoCost: 'Mahhala Ngaphandle kwezindlela',
    freeNoCostSubtitle: `Phuma ezinhleleni, i-photography, imali yokubeka ishadi, kanye nezici zokwenza - sikhulelwe`,
    competetivePrice: 'Inani elikahle',
    competetivePriceSubtitle:
        'Thola inani elikhulu ngaphandle kokuphindaphinda nathi; siziqinisekisa konke okwenza ukuthengiselana nokuzikhululwa',
    carTitle: `Izici Zomshini`,
    carDesc: `Nceda usiphikise izici mayelana nomshini wakho`,
    personalDetail: `Izici Zamntu`,
    personalDetailDesc: `Nceda usiphikise izici mayelana nawe`,
    sellCarHere: `Thengisa Imoto`,
    sellCarHereDesc: `Ungakwazi ukuthenga isu elihle kanye nathi sizobhala imoto yakho`,
    buySellUsedCar: `Thenga futhi thengisa izimoto ezisebenzile kwi`,
    pressPage: {
        title: 'I-Auto24 Yabezindaba',
        description1:
            'I-Auto24 iye yaziwa ezindabeni ezahlukene emhlabeni jikelele.',
        description2:
            'I-Auto24 futhi iye yavezwa ezingqungqutheleni eParis/France, Lisbon/Portugal, Barcelona/Spain, Sydney/Australia, London/UK, Kigali/Rwanda, Bangkok/Thailand, Abidjan/Ivory Coast, Johannesburg/South Africa, Dakar/Senegal, Nairobi/Kenya, Casablanca/Morocco…'
    },
    auto24Press: `i-Auto24 i-Press`,
    auto24PressDesc1: `I-Auto24 ihlanganisiwe kwezindaba ezahlukene emhlabeni wonke.`,
    auto24PressDesc2: `I-Auto24 ikwazile futhi kufinyelelwe kulezinhlelo eParis/France, Lisbon/Portugal, Barcelona/Spain, Sydney/Australia, London/UK, Kigali/Rwanda, Bangkok/Thailand, Abidjan/Ivory Coast, Johannesburg/South Africa, Dakar/Senegal, Nairobi/Kenya, Casablanca/Morocco…`,
    mediaExposure: `Ukuboniswa kwethu kwi-Media`,
    mediaExposureDesc: `Lapha phezulu kukhethwe ukuboniswa kwethu kwi-Media`,
    press: `Isihloko`,
    enterValidPhoneNumber: 'Faka inombolo yomakhalekhukhwini evumelekile',
    sellCar: 'Thengisa imoto',
    findUsGoogle: 'Sithole kuGoogle Map',
    locateUs: 'Sithole',
    whereFindUs: 'Lapho ungathola khona?',
    aroundLocationText: 'Ungasithola kulezi zindawo',
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'Tiktok',
    twitter: 'Twitter',
    youtube: 'Youtube',
    linkedin: 'LinkedIn',
    heroTitle:
        'Indlela esheshayo nelula yokuthi <yellow>Thenga</yellow> noma <green>Thengisa</green> Izimoto',
    caRefundPolicy: 'Inqubomgomo yokubuyiselwa imali',
    caRefundPlicyDesc:
        'Ukubuyisela ngaphandle kwezinkinga. Thola imali yakho uma unganelisekanga.',
    caWarranty: 'Iwaranti',
    caWarrantyDesc:
        'Iwaranti yezinyanga ezi-6. Phumula, imoto yakho ivikelekile.',
    caInspectedDesc:
        'Ikhwalithi iqinisekisiwe. Kuqinisekiswe ithimba lochwepheshe.',
    login: 'Ngena',
    wantToSellYourCar: 'Ufuna ukuthengisa imoto yakho?',
    findUs: 'Sithole',
    featuredCars: 'Izimoto ezifakiwe',
    exploreCarByBodyType: 'Hlola Imoto Ngohlobo Lomzimba',
    searchByBrands: 'Sesha Ngemikhiqizo',
    loanSubtitle:
        'Siyawakhathalela amakhasimende ethu kanye nenjabulo yawo okusikhuthaza ukuthi sihlinzeke ngamasevisi amaningi',
    perfectMatchYourBudget: 'Ukufanisa Okuphelele Kwesabelomali Sakho',
    sellYourVehicle: 'Ufisa Ukuthengisa Imoto Yakho?',
    sellYourVehicleSubtitle:
        'Siyawakhathalela amakhasimende ethu kanye nenjabulo yawo okusikhuthaza ukuthi sihlinzeke ngamasevisi amaningi',
    sellMyCar: 'Thengisa Imoto yami',
    blogTitleMobile: 'Bheka Ngaphambi Kokuthenga',
    blogSubtitleMobile: 'Ukufundwa kwakamuva okuvela ku-auto24',
    readMore: 'Funda kabanzi',
    opps: 'Hhawu!',
    noCarSection:
        'Kubonakala sengathi akukho ukufakwa kuhlu kule segimenti. Ungathanda ukucela imoto?',
    requestCar: 'Cela imoto',
    submitRequestFormSubtitle:
        'Thumela isicelo, futhi sizokusiza uthole imoto efanelekile ehambisana nezidingo zakho.',
    requestCarPageTitle: 'Zitholele Imoto obuyifuna',
    requestCarPageSubtitle:
        'Sazise okuncamelayo, futhi ithimba lethu lizosebenza ukuze likutholele okufanelana nawe. Thumela isicelo sakho namuhla futhi uthole isinyathelo esisodwa eduze nokushayela imoto yakho yamaphupho.',
    viewAll: 'Buka Konke',
    inspection100: 'Amaphuzu angama-100+ okuhlola ochwepheshe bezimoto bethu',
    sixMonthWarranty:
        'Iwaranti yezinsimbi ezisebenzayo izinyanga eziyisi-6 ezingathinteki ekugugeni nasekugqokweni okuvamile.',
    twoCarMaintenance:
        'Ukulungiswa kwezimoto ezimbili yi-Auto24 ezinyangeni eziyi-12',
    towingAndBreakdownAssistance:
        'Usizo lokuhudula kanye nezingozi izinyanga eziyi-12',
    multiCurrencyPayment: 'Inkokhelo ngemali ehlukahlukene FCFA, €, $, £',
    fiveDaysMoneyBack: 'Imbuyiselo yemali ezinsukwini ezi-5',
    vehiclesPaperWork: 'Amaphepha ezimoto aphelele futhi aqinisekisiwe',
    verifyHistory: 'Sihlola umlando wazo zonke izimoto esizithengayo',
    buyBackOldCar: 'Sithenga kabusha imoto yakho endala',
    aboutCar: 'Mayelana neMoto',
    overview: 'Uhlolojikelele',
    carLoan: 'Ukubolekwa Imoto',
    cars: 'Izimoto',
    note: 'Qaphela',
    yourEstimatedMonthlyPayment: 'Inkokhelo yakho yanyanga zonke elinganiselwe',
    applyFilter: 'Faka Isihlungi',
    clearAll: 'Sula Konke',
    carsUnderPriceDescription:
        'I-Auto24 iyindawo yakho ekahle yokuhlola izinhlobo ezahlukene zezimoto ezivela emhlabeni jikelele. Kungakhathaliseki ukuthi ufuna imoto encane yasedolobheni, i-SUV efanele umndeni, noma i-sedan kanokusho, inkundla yethu ikuxhumanisa nezinketho ezihambelana nazo zonke izidingo nezintandokazi zakho. Yonke imikhiqizo yezimoto evezwe ku-Auto24 yaziwa ngobungcweti bayo, ubuchwepheshe bayo, nokwethenjelwa kwayo, ikunikeza ukuthula kwengqondo ekufuneni kwakho imoto ekahle.',
    fuelPriceTracker: 'Umlandeli Wamanani Kawoyela',
    fuelPriceTrackerDesc:
        'Landelela amanani kawoyela kalula usebenzisa ithuluzi lethu! Thola izibuyekezo zesikhathi sangempela ngamanani kawoyela endaweni okuyo, qhathanisa izintengo eziteshini ezahlukene, bese uthola amadili angcono kakhulu eduze kwakho. Londoloza imali futhi wenze izinqumo ezihlakaniphile njalo lapho uthenga uwoyela. Lawula isabelomali sakho—qapha amanani kawoyela namuhla!',
    fuelPriceList: 'Uhlu Lwezintengo Zephethiloli',
    lastUpdateDate: 'Usuku Lokugcina Lokubuyekeza',
    electricityPriceTracker: 'Umkhondo Wamanani kagesi',
    electricityPriceTrackerDesc:
        'Amanani kagesi e{{ Country_name }} angashintsha ngenxa yezilinganiso, ukungabikho kukagesi, kanye nesidingo samandla. Umkhondo Wamanani kagesi wethu uqinisekisa ukuthi uhlale uhamba phambili ngezilinganiso zakamuva ze-Eskom namamanani kagesi ukuze ulawule kahle izindleko zakho zamandla.',
    electricityPriceList: 'Uhlu Lwamamanani kagesi',
    currencyConverter: 'Umguquli Wezimali',
    currencyConverterDesc:
        'Hlala unolwazi ngamanani ashintshashintsha ezimali ngesikhathi sangempela. Kungakhathaliseki ukuthi uhamba, uthenga ku-inthanethi, noma uhweba ngezimali, uMguquli Wezimali wethu ukukusiza uthole amanani angcono ngokushesha.',
    liveExchangeRates: 'Amanani Ezimali Abukhoma',
    updatedAsOf: 'Mis à jour le',
    kmToMi: 'Amakhilomitha kuya kumamayela',
    miToKm: 'Amamayela kuya kumakhilomitha',
    kmToMiConverter: 'Umshini wokuguqula Amakhilomitha abe ngamamayela',
    miToKmConverter: 'Umshini wokuguqula Amamayela abe ngamakhilomitha',
    distanceConverterDesc:
        'Guqula ngokushesha nangokunembile amamayela abe ngamakhilomitha noma okuphambene—kulungele ukuhamba, ukushayela, kanye nokubala kwansuku zonke!',
    mile: 'Imayela',
    kilometer: 'Ikhilomitha',
    howToConvert: 'Ungakuguqula kanjani i-{{ unit }}?',
    benin: 'Benin',
    coteDIvora: "Côte d'Ivoire",
    kenya: 'Kenya',
    southAfrica: 'eNingizimu Afrika',
    morocco: 'iMorocco',
    rwanda: 'uRwanda',
    senegal: 'Senegal',
    tanzania: 'Tanzania',
    togo: 'Togo',
    uganda: 'Uganda',
    vehicleTaxCalculator: 'Isibali sentela yezimoto',
    topCarSales: 'Izimoto ezintsha ezithengiswa kakhulu',
    drivingCostCalculator: 'Isibali sezindleko zokushayela',
    insuranceEstimator: 'Isilinganiso semali ye-inshuwa',
    carLoanCalculator: 'Isibali sesikoloto semoto',
    exploreOtherTools: 'Hlola amanye amathuluzi',
    drivingCostCalculatorDesc:
        'Ukuqonda izindleko zokushayela kubalulekile ekuhleleni nasekuthuthukiseni izindleko zohambo. Noma ngabe uhamba nsuku zonke, uqala uhambo olude ngemoto, noma uphethe iqembu lezimoto, i-Calculator yethu yeziNdleko zokuShayela iyakusiza ulinganise ngokucophelela izindleko zikaphethiloli. Hlela ngaphambili, qhathanisa izindlela, bese wenza izinqumo zohambo ezisebenza kahle kalula.',
    distance: 'Ibanga',
    fuelPrice: 'Inani likaphethiloli',
    enterFuelPrice: 'Faka inani likaphethiloli',
    fuelEconomy: 'Ukonga uphethiloli',
    estimatedDrivingCost: 'Izindleko zakho zokushayela ezilinganiselwe yi',
    enterAllValues: 'Faka zonke izinombolo ukuze ubale',
    startAddress: 'Ikheli lokuqala',
    endAddress: 'Ikheli lokugcina',
    startAddressPlaceholder: 'Faka ikheli lokuqala',
    endAddressPlaceholder: 'Faka ikheli lokugcina',
    orEnterDistanceManually: 'Noma faka ibanga ngesandla',
    enterDistance: 'Faka ibanga',
    manualDistance: 'Ibanga lesandla',
    calculatedFromAddresses: 'Kubaliwe kusuka kumakheli',
    priceUpdatedFromAPI:
        'Inani lihlaziyiwe kusuka kuminingwane yamanje yentengo yepetroli',
    emissionEstimator: 'Isibali se-CO2',
    emissionEstimatorDesc:
        'Kala umthelela wakho endaweni okuphila kuyo bese uthole izindlela zokunciphisa i-CO2 yakho ezithuthweni, ekusetshenzisweni kwamandla, nasemikhubeni yansuku zonke. Lawula imizamo yakho yokuqhubeka nokuthuthuka bese unikela emhlabeni onempilo.',
    estimatedEmission: 'I-CO2 elinganiselwe yakho yi',
    emissionFactor: 'Umlinganiso we-CO2',
    efficiency: 'Ukusebenza',
    bestSellingCarsOfYear:
        'Izimoto ezithengiswa kakhulu zonyaka {{ CurrentYear }}',
    discoverBestSellingCarsOfYear:
        'Thola izimoto ezithengiswa kakhulu zonyaka {{ CurrentYear }}: Uhlolo oluphelele lwezindlela zezimoto emhlabeni, amamodeli athengiswa kakhulu, kanye nokukhula kwezimoto zikagesi.',
    loanAmount: 'Inani Lemalimboleko',
    carLoanCalculatorDesc:
        'Hlela ukuthenga imoto yakho elandelayo ngokuzethemba ngokubala izinkokhelo zanyanga zonke, izinga lenzalo eliphelele, nezindleko zebhange. Kungakhathaliseki ukuthi uthenga entsha noma esetshenzisiwe, leli thuluzi likusiza ukuthola imali mboleko ehambisana nesabelomali sakho.',
    vehicleTechnicalDocuments: 'Amadokhumenti Ezobuchwepheshe Ezimoto',
    vehicleTechnicalDocumentsDesc:
        'Nazi zonke izimoto namadokhumenti azo ezobuchwepheshe.',
    vehicleName: 'Igama Lemoto',
    fileSize: 'Usayizi Wefayela',
    modifiedDate: 'Usuku Oluguquliwe',
    action: 'Isenzo',
    downloadDoc: 'Landa Umdokhumenti',
    technicalDocs: 'Amadokhumenti ezobuchwepheshe',
    dataNotAvailable: 'Amarekhodi awatholakali.',
    documentsAvailable: 'amadokhumenti atholakalayo',
    downloadError: 'Yehlulekile ukulanda',
    failedToDownload:
        'Kube nephutha ngenkathi kulandwa ifayela. Sicela uzame futhi emuva noma uxhumane nathi ukuthola usizo.',
    close: 'Vala',
    priceRangeList: 'Izimoto kusukela ku {{min}} kuya ku {{max}}',
    comingCarsSubtitle: 'Lapha ungabona izimoto ezahlukene ezizofika maduze',
    buyComingCars: 'Izimoto Ezizayo',
    buyAllCars: 'Izimoto Zose',
    buyNewCars: 'Izimoto Ezintsha',
    incoming: 'Ezizayo',
    referAndEarnPage: {
        title: 'Xhumanisa futhi Uthole Imali',
        hero: {
            title: 'Xhumanisa futhi Uthole Imali ne-Auto24',
            desc: 'Xhumanisa kalula abantu abafuna ukuthenga imoto ne-Auto24 uthole umklomelo lapho ukuxhumanisa kwakho kuphumelele. Uhlelo lula ukujoyina, lumahhala, futhi aludingi mali yangaphambili. Ungaxhumanisa abathengi abaningi ngendlela ofuna ngayo, ulandelele ukuxhumanisa kwakho, futhi uthole imali kuyo yonke imininingwane eqinisekisiwe — akukho mkhawulo wokuthi ungathola malini kangakanani.'
        },
        howItWorks: {
            title: 'Kusebenza Kanjani',
            desc: 'Xhumanisa abathengi abafuna imoto ku-Auto24 uthole umklomelo lapho ukuxhumanisa kuphumelele.\n\nI-Auto24 inikeza izindlela ezimbili zokuxhumanisa:',
            planA: {
                title: 'Uhlelo A',
                desc: 'Xhumanisa ikhasimende elinemininingwane yokusekela ephelele futhi uthole',
                amount: 'R2,500',
                per: '/ngokuxhumanisa okuphumelele ngakunye'
            },
            planB: {
                title: 'Uhlelo B',
                desc: 'Xhumanisa ikhasimende ngaphandle kwemininingwane yokusekela futhi uthole',
                amount: 'R1,000',
                per: '/ngokuxhumanisa okuphumelele ngakunye'
            },
            importantInfo: {
                title: 'Ulwazi Olubalulekile',
                items: [
                    'Kufanele ubhalise ngaphambi kokuthumela ukuxhumanisa',
                    'Akukho mali yokubhalisa',
                    'Ungaxhumanisa abathengi abangenamkhawulo',
                    'Ukuxhumanisa kungathunyelwa ku-inthanethi',
                    'Imiklomelo ikhokhwa kuphela ngemva kokuphumelela kokuxhumanisa'
                ]
            }
        },
        getStarted: {
            title: 'Ukuqala Kanjani?',
            steps: [
                {
                    title: 'Bhalisa',
                    desc: 'Bhalisa usebenzisa ifomu ngezansi.'
                },
                {
                    title: 'Hambisa Isithenjwa',
                    desc: 'Faka imininingwane yekhasimende olithumelayo.'
                },
                {
                    title: 'Siyaxhumana Nabo',
                    desc: 'I-Auto24 ixhumana nekhasimende elithunyelwe.'
                },
                {
                    title: 'Thola Imali',
                    desc: 'Thola umklomelo wakho uma isithenjwa sesiqinisekisiwe.'
                }
            ],
            startReferring: {
                title: 'Qala Ukuthumela Namuhla',
                desc1: 'Gcwalisa imininingwane yakho ukuze uthole ulwazi olwengeziwe futhi uqale ukuthola imali nge-Auto24.',
                desc2: 'Kusebenza imigomo nemibandela.'
            }
        }
    },
    financePage: {
        financeHero: {
            title: '<yellow>Xhasa</yellow> <green>Imoto Yakho</green> Nge-AUTO24',
            desc: 'Ukuxhasa imoto yakho eqinisekisiweyo esetshenzisiwe nge-AUTO24, kulula kakhulu futhi ngezinyathelo ezintathu kuphela:',
            step1: 'Ukhetha imoto yakho',
            step2: 'Ulanda yonke imibhalo edingekayo',
            step3: 'Ulinda ukuvunywa kwangaphambili kwe bhange',
            fastAndSimple: 'Kushesha futhi kulula!',
            agent: 'Omunye wabacebisi bethu bezimali uzobheka ifayela lakho futhi akukhokhele kwinqubo.'
        },
        whyChooseUs: {
            title: 'Kungani Ukhetha i-AUTO24',
            featureTitle1: 'Ifa le-AUTO24',
            featureDesc1:
                'Sizuze indawo yethu njengomthengisi ohamba phambili wezimoto ezisetshenzisiwe e-Afrika, sakha ifa elakhiwe eminyakeni yenkonzo ephakeme, ukwaneliseka kwabathengi, kanye nokugxila enanini.',
            featureTitle2: 'Ukuhlola Okungqongqo',
            featureDesc2:
                'Izimoto zethu zihlolwa ngokungqongqo ngamaphuzu angu-120 ukuze kuqinisekiswe ukuthi uthenga imoto yekhwalithi ephezulu. Kusukela enjini kuya ekushiseni, yonke imininingwane ihlolwa ngokucophelela ngabacwaningi bethu abangochwepheshe.',
            featureTitle3: 'Izinto Eziyingqayizivele',
            featureDescItem1:
                'Inqubomgomo Yokubuyisela Izimali Yezinsuku Ezinhlanu: Uma unganelisekile ngokuthenga kwakho, inqubomgomo yethu yokubuyisela izimali yezinsuku ezinhlanu iyakuvikela.',
            featureDescItem2:
                'Iwaranti Yezinyanga Eziyisithupha: Sinikeza iwaranti yezinyanga eziyisithupha kuzo zonke izimoto zethu ukuqinisekisa ukuthula kwengqondo yakho.',
            featureDescItem3:
                'Iphakheji Yomshwalense Wonyaka Owodwa: Shaya ngokuphepha ngephakheji yethu yomshwalense wonyaka owodwa.',
            featureDescItem4:
                'Iphakheji Yokulungisa Wonyaka Owodwa: Phumula, sinikeza iphakheji yokulungisa unyaka wokuqala wobunikazi.',
            featureTitle4: 'Ukuqinisekiswa Kwemibhalo',
            featureDesc4:
                'Yonke imibhalo nomlando wesithuthi kuhlolwa ngokucophelela ukuze kuqinisekiswe ubuqiniso bezimpahla zakho.',
            featureTitle5: 'Ukuhweba Okungenazinkinga',
            featureDesc5:
                'Sinikeza ukuhweba nokuthengisa okusheshayo nokuphephile, okwenza ulwazi lwakho lube lula ngangokunokwenzeka.'
        },
        qualitySection: {
            title: 'Ikhwalithi, Ukwethembela, kanye Nokuvuleleka',
            desc: 'I-AUTO24 ayiyona nje indawo yezentengiselwano; iwumphakathi lapho ukwethembela okuhlala isikhathi eside kwakhiwa khona. Sihlose ukukusiza ukuthi uthathe izinqumo ezinolwazi, sinikeza ulwazi olungenakuqhathaniswa nalo olungekho kwenye indawo.',
            desc2: 'Noma ngabe ungumthengi wokuqala noma umshayeli onolwazi, i-AUTO24 inokuthile engakunikeza yona. Woza uhlola umhlaba wamathuba nathi.',
            imageAlt: 'Ukwethembela kanye Nobudlelwano'
        },
        whyFinanceSection: {
            title: 'Kungani Uxhasa Imoto Yakho Nge-AUTO24',
            desc: 'Sikunikeza okungcono kakhulu kokuxhasa ngemali ngenzalo ephansi kanye nezinkokhelo zokuqala eziphansi.',
            featureTitle1: 'Amanani Okuncintisana',
            featureDesc1: 'I-APR Kusukela ku-5% (okuyisibonelo)',
            featureTitle2: 'Izikhathi Eziguquguqukayo',
            featureDesc2:
                'Khokha imoto yakho ngezinkokhelo zenyanga ezili-12 kuya kwezingu-72',
            featureTitle3: 'Indlela Ye-100% Ye-Intanethi',
            featureDesc3: 'Sayina yonke imibhalo yakho usekhaya'
        },
        ourFinancingPartnerSection: {
            title: 'Abaxhasi Bethu Bezemali',
            desc: 'Naba abanye babaxhasi bethu bezemali'
        }
    },
    insureHero: {
        title: '<yellow>Shwalensa</yellow> <green>Imoto Yakho</green> Nge-AUTO24',
        desc: 'Ngemuva kokuthenga imoto yakho, esinye sezinyathelo ezibaluleke kakhulu ukuthola ipholisi yomshwalense efanele.',
        desc2: 'Kodwa nge-AUTO24 kanye nomlingani wethu i-WiAssur, akukho ukucindezeleka, kuzoba yinqubo elula futhi elula. Uzojabulela ipholisi yomshwalense engcono kakhulu kuwe kanye nemoto yakho, ngentengo engcono kakhulu.',
        desc3: 'Omunye wabacebisi bethu bomshwalense uzobheka ifayela lakho futhi akukhokhele kwinqubo.'
    },
    // Voetstoots Trade Sale translations
    voetstoots: 'Voetstoots',
    voetstootsTradeSaleTitle: 'Isikhungo Sokuthengiswa Se-Auto24',
    voetstootsTradeSaleSubtitle:
        'Thenga izimoto zokutshintshiselana njengoba zinjalo ngenani elihla — azikho iziqinisekiso, azikho ukubuyisela.',
    voetstootsTradeSaleWarningDetails:
        'Izimoto ze-Auto24 Trade Centre zithengiswa njengoba zinjalo, ngaphandle kweziqinisekiso, izimbuyiselo, noma ukulungiswa. Abathengi bayamukela ngokuphelele umthwalo wokuhlola, ukufaneleka komgwaqo, kanye nezindleko zesikhathi esizayo.',
    voetstootsTradeSaleList1: 'Kuthengiswe voetstoots (njengoba injalo)',
    voetstootsTradeSaleList2:
        'Azikho iziqinisekiso noma iziqinisekiso ezisebenzayo.',
    voetstootsTradeSaleList3: 'Ukulungisa nokonakala kungendleko yomthengi.',
    voetstootsTradeSaleList4:
        'Azikho ukubuyisela, ukubuyisela imali, noma ukutshintshiselana.',
    voetstootsTradeSaleList5:
        'Isiqinisekiso sokufaneleka kwendlela asifakwanga.',
    voetstootsTradeSaleList6:
        'Izinkinga ezaziwayo ziyabhengezwa, izinkinga ezifihlakeleyo zingenzeka.',
    voetstootsTradeSaleLearnMore: 'FUNDA OKUNINGI',
    voetstootsTradeSaleCarsTitle: 'Izimoto Zokuthengiswa',
    voetstootsTradeSaleCarsSubtitle:
        'Lapha ungabona izimoto ezahlukene zokuthengiswa',
    voetstootsTradeSaleViewAll: 'BHEKA ZONKE IZIMOTO',
    voetstootsTradeSalePageTitle: 'Isikhungo Sokuthengiswa',
    voetstootsTradeSalePageDesc:
        'Isikhungo Sokuthengiswa Se-Auto24 sinikezela izimoto zokutshintshiselana ngenani elihla Voetstoots, okusho ukuthi izimoto ziyathengiswa kanye nazo zonke izinkinga, kungakhathaliseki ukuthi zibonakalayo noma zifihlakeleyo. Ziqinisekiso, ukubuyisela, noma ukulungisa akufakwanga, futhi abathengi bayamukela umthwalo wemfanelo ogcwele wanoma yiziphi izindleko zesikhathi esizayo noma ukonakala. Ngaphandle kokuba kuchazwe ngokuhlukile, izimoto ziyathengiswa ngaphandle kwesiqinisekiso sokufaneleka kwendlela, futhi nakuba izinkinga ezaziwayo ezinkulu ziya kubhengezwa, izinkinga ezifihlakeleyo zingasahlala zikhona. Abathengi bayakhuthazwa ukuba bahlole izimoto ngokucophelela ngaphambi kokuthenga, futhi ubunikazi budluliselwa kuphela ngemuva kokuthola inkokhelo egcwele.',
    voetstootsTradeSalePageKeywords:
        'voetstoots, ukuthengiswa, izimoto njengoba zinjalo, izimoto ezihla inani, azikho isiqinisekiso',
    // WhatsApp Banner
    whatsappBanner: {
        discover: 'Thola',
        exclusive: 'Okukhethekile',
        deals: 'Amadili',
        stayUpdatedWithLatestNews:
            'Hlala unolwazi ngezindaba zakamuva, izibuyekezo namadili akhethekile',
        offersStraightToWhatsApp: 'izinikezelo ngqo kuWhatsApp yakho.',
        getLatestCarNewsAmazingTips:
            'Thola izindaba zakamuva zezimoto, amathiphu amangalisayo namadili eWhatsApp akhethekile. Yiba ngowokuqala ukwazi ngamadili ethu amahle ngokulandela isiteshi sethu – ungaphoswa leli thuba!',
        joinChannel: 'JOINA ISITESHI'
    },
    view: 'BHEKA',
    openPdf: 'VULA I-PDF'
};

export default commonZulu;
